
/**
 * 下拉弹窗包装器组件
 * 用于处理基于输入框的下拉弹窗定位
 */
export default {
  name: 'ManualContainer',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    zIndex: {
      type: Number,
      default: 2001
    }
  },
  methods: {
    handleScroll() {
        // 处理滚动事件
        this.$emit('scroll')
        // 在这里添加你需要的滚动处理逻辑
    }
  }
}
